import { render } from "./SMenuCard.vue?vue&type=template&id=5eebeca2&scoped=true"
import script from "./SMenuCard.vue?vue&type=script&lang=js"
export * from "./SMenuCard.vue?vue&type=script&lang=js"

import "./SMenuCard.vue?vue&type=style&index=0&id=5eebeca2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5eebeca2"

export default script